export default __webpack_public_path__ + "static/media/downloadIcon.c0ee090d.svg";